module.exports = __webpack_public_path__ + "media/components/country-flag/static/fo-b3b9fd758fdc340e789fc90170e35877.svg";